import { useState, useEffect } from "react";
import DashboardLayout from "../common/DashboardApp";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getBankData,
  addBankData,
  updateBankData,
} from "../../../service/api";

const Bank = () => {
  const location = useLocation();

  const [bankDetails, setBankDetails] = useState({
    id: "",
    accountType: "Saving",
    accountHolderName: "",
    accountNumber: "",
    ifscCode: "",
    branchName: "",
  });

  const [loading, setLoading] = useState(false);

  // ✅ Show toast message if redirected
  useEffect(() => {
    if (location.state?.toastMessage) {
      toast.success(location.state.toastMessage);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  // ✅ Fetch bank details from API
  useEffect(() => {
    const fetchBankDetails = async () => {
      try {
        const res = await getBankData();

        if (res && res.data) {
          setBankDetails({
            id: res.data.id,
            accountType: res.data.accountType,
            accountHolderName: res.data.accountHolderName,
            accountNumber: res.data.accountNumber,
            ifscCode: res.data.ifscCode,
            branchName: res.data.branchName,
          });
        }
      } catch (err) {
        console.error("Error fetching bank details:", err);
      }
    };

    fetchBankDetails();
  }, []);

  // ✅ Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBankDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ✅ Handle submit (create or update)
const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    let res;
    if (bankDetails.id) {
      // Update existing record
      res = await updateBankData(bankDetails);
      console.log("Update response:", res);
      toast.success("Bank details updated successfully!");
    } else {
      // Create new record
      res = await addBankData(bankDetails);
      console.log("Create response:", res);
      toast.success("Bank details added successfully!");
    }
  } catch (err) {
    if (err.response) {
      // backend responded with an error
      console.error("API Error Response:", err.response.data);
      toast.error(err.response.data?.message || "Something went wrong while saving bank details");
    } else if (err.request) {
      // no response from server
      console.error("No Response:", err.request);
      toast.error("No response from server");
    } else {
      // error setting up request
      console.error("Error:", err.message);
      toast.error("Unexpected error occurred");
    }
  } finally {
    setLoading(false);
  }
};


  return (
    <DashboardLayout>
      <div className="panelMainWrapper">
        <div className="panelCard">
          <div className="titlSectionu userpaneltitle text-left position-relative">
            <h2>Bank Details</h2>
            <p>Manage your bank details</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="row hj-form">
              <div className="col-md-6 col-lg-4 mb-3">
                <label>Account Type</label>
                <select
                  className="form-select"
                  name="accountType"
                  value={bankDetails.accountType}
                  onChange={handleChange}
                  required
                >
                  <option value="Saving">Saving</option>
                  <option value="Current">Current</option>
                  <option value="Salary">Salary</option>
                </select>
              </div>

              <div className="col-md-6 col-lg-4 mb-3">
                <label>Account Holder Name</label>
                <input
                  type="text"
                  name="accountHolderName"
                  className="form-control"
                  required
                  value={bankDetails.accountHolderName}
                  onChange={handleChange}
                />
                <input type="hidden" name="bank_id" value={bankDetails.id} />
              </div>

              <div className="col-md-6 col-lg-4 mb-3">
                <label>Account Number</label>
                <input
                  type="number"
                  name="accountNumber"
                  className="form-control"
                  required
                  value={bankDetails.accountNumber}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 col-lg-4 mb-3">
                <label>IFSC</label>
                <input
                  type="text"
                  name="ifscCode"
                  className="form-control"
                  required
                  maxLength="11"
                  value={bankDetails.ifscCode}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 col-lg-4 mb-3">
                <label>Branch Name</label>
                <input
                  type="text"
                  name="branchName"
                  className="form-control"
                  required
                  value={bankDetails.branchName}
                  onChange={handleChange}
                />
              </div>

              <div className="col-12">
                <button
                  type="submit"
                  className="mt-2 normalbtn"
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Update Bank Details"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Bank;
